module.exports = __webpack_public_path__ + "img/mobile.4986a48b.png";